import { type IHotelState } from "../features/hotel/hotelInterface";

export const vatRates: Record<
  IHotelState["HotelCode"],
  { rooms: number; products: number }
> = {
  AMS: { rooms: 0.21, products: 0.09 },
  RTM: { rooms: 0.21, products: 0.09 },
  CPH: { rooms: 0.25, products: 0.25 },
  RKV: { rooms: 0.11, products: 0.11 },
};
